import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, Input, Output, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { User } from 'pdauth';

import { UserApi } from '../../../api/user-api';
import { IAuthenticationService } from '../../../services/interfaces/IAuthenticationService';
import { MapService } from '../../../services/map.service';
import { IMapCoreMap } from '../../../types';
import { BaseComponent } from '../../base.component';

@Component({
   encapsulation: ViewEncapsulation.ShadowDom,
   selector: 'mc-unshare-map',
   templateUrl: './unshare-map.component.html',
   styleUrls: ['../../sharedStyles/base.scss', './unshare-map.component.scss']
})
export class UnShareMapComponent extends BaseComponent implements AfterViewInit {

    private _map: IMapCoreMap;
    @Input() set map(value: IMapCoreMap) {
        if (value) {
            this._map = value;
            this.getSharedUsers();
        }
    }
    get map(): IMapCoreMap {

        return this._map;
    }

    canViewUsers = false;
    success = false;
    sharedUsers: User[];
    unSharedUsers: User[];

    @Output() readonly closeUnshareMap: EventEmitter<void> = new EventEmitter<void>();

    constructor(_vcr: ViewContainerRef,
                @Inject('authenticationService') private readonly authService: IAuthenticationService,
                private readonly mapService: MapService,
                private readonly userApi: UserApi,
                private readonly changeRef: ChangeDetectorRef) {
        super(_vcr);
        this.registerEvent('closeUnshareMap', this.closeUnshareMap);
        this.authService.permissions.subscribe(permissions => {
            this.canViewUsers = permissions && permissions.includes('View Users');
        });
    }

    ngAfterViewInit() {
        this.isReady();
    }

    async getSharedUsers() {
       this.resetSuccess();
       this.unSharedUsers = [];
       const userIds: number[] = this.map.sharedWith.map((u: any) => u.userId);

       this.sharedUsers = await this.userApi.getUsers(userIds, this.canViewUsers);
       this.changeRef.detectChanges();
    }

    resetSuccess() {
        this.success = false;
        this.changeRef.detectChanges();
    }

    unshareUser(index) {
        this.unSharedUsers = [...this.unSharedUsers, ...this.sharedUsers.splice(index, 1)];
        this.changeRef.detectChanges();

    }
    reshareUser(index) {
        this.sharedUsers = [...this.sharedUsers, ...this.unSharedUsers.splice(index, 1)];
        this.changeRef.detectChanges();
    }

    async unShare() {
        const userIds: number[] = this.unSharedUsers.map((u: any) => u.id);
        await this.mapService.unShareMap(userIds, this.map.id);
        this.success = true;
        this.unSharedUsers = [];
        this.changeRef.detectChanges();
    }

    async close() {
        this.closeUnshareMap.emit();
    }

}
